import {
	Card,
	CardContent,
	CardHeader,
	type CardProps,
	type CardContentProps,
	type CardHeaderProps,
	TypographyProps,
	Typography,
	Button,
	ButtonProps,
} from '@mui/material'
import { ComponentProps, type ComponentType } from 'react'
import { styled } from '@mui/material/styles'
import { Add, ForumOutlined } from '@mui/icons-material'

import { STACKED_HEADER_BREAKPOINT } from '../../utils'

export const AvailableCard: ComponentType<CardProps> = styled( Card )( ( { theme } ) => ( {
	borderRadius: theme.shape.borderRadius,
	boxShadow: 'none',
	border: `1px solid ${theme.palette.grey[ 300 ]}`,
	padding: theme.spacing( 1, 2, 2, 2 ),
	containerType: 'inline-size',
} ) )

export const AvailableCardHeader: ComponentType<CardHeaderProps> = styled( CardHeader )( ( { theme } ) => ( {
	marginBottom: theme.spacing( 2 ),

	[ `@container (max-width: ${STACKED_HEADER_BREAKPOINT}px)` ]: {
		'alignItems': 'flex-start',
		'flexDirection': 'column',

		'& .MuiCardHeader-avatar': {
			marginBottom: theme.spacing( 1 ),
			marginRight: 0,
		},
	},
} ) )

export const AvailableCardContent: ComponentType<CardContentProps> = styled( CardContent )( () => ( {} ) )

// The active integration card's divider sits inside a CardContent, so it is inset by that
// component's horizontal padding. Match it here so both grids line up.
export const AvailableCardDivider: ComponentType<ComponentProps<'hr'>> = styled( 'hr' )( ( { theme } ) => ( {
	marginLeft: theme.spacing( 2 ),
	marginRight: theme.spacing( 2 ),
} ) )

export const AvailableCardTitle: ComponentType<TypographyProps> = styled( Typography )( ( { theme } ) => ( {
	fontWeight: theme.typography.fontWeightMedium,
} ) )

export const StyledButton: ComponentType<ButtonProps> = styled( Button )( ( { theme } ) => ( {
	paddingLeft: theme.spacing( 1 ),
	paddingRight: theme.spacing( 2 ),
} ) )

export const IntegrationImage: ComponentType<ComponentProps<'img'>> = styled( 'img' )( ( { theme } ) => ( {
	width: 100,
	height: 60,
	objectFit: 'contain',
	borderRadius: theme.shape.borderRadius,
	marginRight: theme.spacing( 2 ),

	[ `@container (max-width: ${STACKED_HEADER_BREAKPOINT}px)` ]: {
		marginRight: 0,
	},
} ) )

export const StyledAddIcon: ComponentType<ComponentProps<typeof Add>> = styled( Add )( ( { theme } ) => ( {
	fontSize: '1.5rem',
	marginRight: theme.spacing( 0.5 ),
	marginLeft: 0,
} ) )

export const StyledChatIcon: ComponentType<
	ComponentProps<typeof ForumOutlined>
> = styled( ForumOutlined )( ( { theme } ) => ( {
	fontSize: '1.5rem',
	marginRight: theme.spacing( 1 ),
	marginLeft: theme.spacing( 0.5 ),
} ) )
